import Language from '@/utils/Language.js'
import Country from '@/utils/Country.js'

const isValidDate = function (string) {
    let timestamp = Date.parse(string);
    if (isNaN(timestamp) == false) {
        return true;
    }
    return false;
}

const isValidUrl = function (string) {
    let url;
    try {
        url = new URL(string);
    } catch (_) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}

const validate = function (menu) {
    let errorMessages = [];
    //nombre
    if (!menu.name) {
        errorMessages.push("Es necesario introducir un nombre.");
    }
    //tipo
    if (!menu.type) {
        errorMessages.push("Es necesario seleccionar un tipo.");
    }
    return errorMessages;
};

const validateItem = function(item) {
    let errorMessages = [];
    //nombre
    if (!item.name) {
        errorMessages.push("Es necesario introducir un nombre.");
    }
    //clase css
    if (!item.css_class) {
        errorMessages.push("Es necesario introducir la clase CSS.");
    }
    //paises
    if (item.origin_countries.length > 0) {
        const countries = Country.getCountries();
        item.origin_countries.forEach(function (country_id) {
            if (!countries[country_id]) {
                errorMessages.push("El país seleccionado no es válido.");
            }
        });
    }
    //periodos de validez
    if (item.valid_dates.length > 0) {
        item.valid_dates.forEach(function (dates) {
            if (dates['from'] && dates['to']) {
                if (!isValidDate(dates['from'])) {
                    errorMessages.push("La fecha 'desde' " + dates['from'] + " no es válida");
                }
                if (!isValidDate(dates['to'])) {
                    errorMessages.push("La fecha 'hasta' " + dates['to'] + " no es válida");
                }
                let from = new Date(dates['from']);
                let to = new Date(dates['to']);
                if (from > to) {
                    errorMessages.push("La fecha 'desde' " + dates['from'] + " es posterior a la fecha 'hasta' " + dates['to']);
                }
            } else if (dates['from'] && !dates['to']) {
                errorMessages.push("Falta la fecha 'hasta' para la fecha 'desde' " + dates['from']);

            } else if (!dates['from'] && dates['to']) {
                errorMessages.push("Falta la fecha 'desde' para la fecha 'hasta' " + dates['to']);
            }
        });
    }
    //idiomas
    if (Object.keys(item.langs).length > 0) {
        const languages = Language.getLanguages();
        for (let key in item.langs) {
            if (item.langs[key]['text'] == "") {
                errorMessages.push("El texto en el idioma " + languages[key] + " está vacío.");
            }
            if (item.langs[key]['url'] == "") {
                errorMessages.push("La URL en el idioma " + languages[key] + " está vacía.");
            } else {
                if (!isValidUrl(item.langs[key]['url'])) {
                    errorMessages.push("La URL " + item.langs[key]['url'] + " en el idioma " + languages[key] + " no es válida.");
                }
            }
        }
    } else {
        errorMessages.push("Es necesario introducir texto y URL en algún idioma.");
    }
    return errorMessages;
};

export default {
    validate,
    validateItem
};
